var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BasePaymentForm", {
    staticClass: "custom-payment-form",
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "icon form-group mt-2 mb-1 text-danger" },
              [
                _c("i", { staticClass: "fas fa-exclamation-circle mb-2" }),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("apps.payment.message.paymentfailedheader")
                      ) +
                      "\n      "
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "summary form-group mt-3 mb-0" }, [
              _c("div", { staticClass: "section" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("apps.payment.message.paymentfaileddetail")) +
                    "\n      "
                )
              ])
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer-actions",
        fn: function() {
          return [
            _c("BaseButton", {
              attrs: {
                text: _vm.$t("button.gotohomepage"),
                className: "btn-web"
              },
              on: { click: _vm.onClickNext }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1187e9a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1187e9a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/paymentpackage/PaymentFail.vue
// module id = null
// module chunks = 